import React from 'react'
import noIcon from '../../../../assets/images/icons/noIcon.svg'
import aps from '../../../../assets/images/icons/aps.svg'
import astropay from '../../../../assets/images/icons/astropay.svg'
import beeteller from '../../../../assets/images/icons/beeteller.svg'
import brightcart from '../../../../assets/images/icons/brightcart.svg'
import centiwise from '../../../../assets/images/icons/centiwise.svg'
import coinpayments from '../../../../assets/images/icons/coinpayments.svg'
import coinspaid from '../../../../assets/images/icons/coinspaid.svg'
import EmiratesIB from '../../../../assets/images/icons/EmiratesIB.svg'
import fasapay from '../../../../assets/images/icons/fasapay.svg'
import findguide from '../../../../assets/images/icons/findguide.svg'
import H1 from '../../../../assets/images/icons/H1.svg'
import help2pay from '../../../../assets/images/icons/help2pay.svg'
import HG from '../../../../assets/images/icons/HG.svg'
import jenapay from '../../../../assets/images/icons/jenapay.svg'
import kora from '../../../../assets/images/icons/kora.svg'
import kassarub from '../../../../assets/images/icons/kassarub.svg'
import Mashreq from '../../../../assets/images/icons/Mashreq 1.svg'
import neteller from '../../../../assets/images/icons/neteller 1.svg'
import ozow from '../../../../assets/images/icons/ozow.svg'
import pas from '../../../../assets/images/icons/pas.svg'
import paylivre from '../../../../assets/images/icons/paylivre.svg'
import payretailers from '../../../../assets/images/icons/payretailers.svg'
import Pear2Pay from '../../../../assets/images/icons/Pear2Pay.svg'
import Sber from '../../../../assets/images/icons/Sber.svg'
import skrill from '../../../../assets/images/icons/skrill.svg'
import spayz from '../../../../assets/images/icons/spayz.svg'
import standardBank from '../../../../assets/images/icons/standard-bank.svg'
import sticpay from '../../../../assets/images/icons/sticpay.svg'
import trust from '../../../../assets/images/icons/trust.svg'
import thunderxpay from '../../../../assets/images/icons/thunderxpay.svg'
import ubank from '../../../../assets/images/icons/ubank.svg'
import UniCreditBank from '../../../../assets/images/icons/UniCredit-Bank-Emblem.svg'
import webpayment from '../../../../assets/images/icons/webpayment.svg'

const iconMap: Record<string, string> = {
  aps: aps,
  apsmoney: aps,

  astropay: astropay,

  beeteller: beeteller,

  brightcard: brightcart,
  brightcart: brightcart,

  centiwise: centiwise,

  closedtrustwalletdontuse: trust,

  coinpayments: coinpayments,

  coinspaid: coinspaid,
  coinspaidbusinesswallet: coinspaid,
  coinspaiddirect: coinspaid,
  coinspaidbuisnesswallet: coinspaid,

  emiratesib: EmiratesIB,
  emiratesislamicbank: EmiratesIB,

  fasapay: fasapay,

  findguide: findguide,

  h1: H1,
  h1альфабанк: H1,

  h2p: help2pay,

  hdlsber: Sber,
  hdlunicb: UniCreditBank,

  help2pay: help2pay,
  help2payh2p: help2pay,

  hg1: HG,
  hg2: HG,
  hg3: HG,
  hg4: HG,
  hg5: HG,
  hg6: HG,
  hg7: HG,
  hg8: HG,

  jenapay: jenapay,

  kassarub: kassarub,

  kora: kora,

  mashreq: Mashreq,

  neteller: neteller,

  ozow: ozow,

  pas: pas,
  pas2: pas,

  paymentasia: pas,
  paymentasia2: pas,
  paymentasia2pas2: pas,
  paymentasiapas: pas,

  paylivre: paylivre,

  payretailers: payretailers,

  pear2pay: Pear2Pay,

  sber: Sber,

  skrill: skrill,

  spayz: spayz,

  standardbank: standardBank,
  standartbank: standardBank,

  sticpay: sticpay,

  thunderxpay: thunderxpay,

  trustsettl: trust,
  trustsettl2: trust,
  trustsettl3: trust,

  trustsettlh2p: trust,
  trustsettlh2p2: trust,
  trustsettlh2p3: trust,

  trustsettljenapay: trust,

  trustsettlkora: trust,

  trustsettlspayz: trust,
  trustsettlspayz2: trust,
  trustsettlspayz3: trust,
  trustsettlspayz4: trust,

  trustsettlwebpayment: trust,
  trustsettlwp: trust,

  ubank: ubank,

  unicb: UniCreditBank,
  unicredit: UniCreditBank,
  unicreditbank: UniCreditBank,

  webpayment: webpayment,
}

const normalize = (name: string) =>
  name
    .trim()
    .toLowerCase()
    .replace(/[()]/g, '')
    .replace(/[_\-\s]+/g, '')
    .replace(/[^a-zа-я0-9]/gi, '')

type CryptoIconProps = {
  name: string
  size?: number
}

export const CryptoIcon: React.FC<CryptoIconProps> = ({ name, size = 20 }) => {
  const src = iconMap[normalize(name)] ?? noIcon

  return (
    <img
      src={src}
      alt={name}
      width={size}
      height={size}
      style={{ verticalAlign: 'middle', flexShrink: 0, objectFit: 'contain' }}
    />
  )
}
